import { CalendarIcon, InputWrap, Popover } from '@libs/ui/ds'
import { DatePickerInputClearButton } from '@libs/ui/ds/lib/components/dates/datePickerUtils/subs/DatePickerInputClearButton'
import { InputBase } from '@libs/ui/ds/lib/components/inputs/InputBase/base/InputBase'
import React from 'react'
import type { FC } from 'react'

import type { DatePickerTargetInputProps } from '../../DatePickerInput.types'

export const DatePickerTargetInput: FC<DatePickerTargetInputProps> = ({
  syncDate,

  /** InputWrap Props */
  label,
  disabled = false,
  className,
  required,
  errorMessage,
  desc,
  readOnly = false,
  rightSection,
  onClear,
  clearable = false,
  pickerOnly,

  /** Calendar Props */
  placeholder,
  ...other
}) => {
  return (
    <Popover.Target>
      <InputWrap
        label={label}
        disabled={disabled}
        className={className}
        required={required}
        errorMessage={errorMessage || syncDate.errorMessage}
        desc={desc}
        data-testid={other['data-testid']}
        field={
          <InputBase
            data-testid='date-picker-input'
            value={syncDate.strValue}
            onClick={e => e.preventDefault()}
            onChange={e => syncDate.onChangeStr(e.target.value)}
            type='date'
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly || pickerOnly}
            error={Boolean(errorMessage || syncDate.errorMessage)}
            leftIcon={<CalendarIcon />}
            rightSection={
              <DatePickerInputClearButton
                disabled={disabled}
                fallback={rightSection}
                clearable={clearable}
                readOnly={readOnly}
                onClear={e => {
                  onClear?.(e)
                  syncDate.reset()
                }}
              />
            }
          />
        }
      />
    </Popover.Target>
  )
}
